module.exports = __webpack_public_path__ + "img/mail.58412f65.svg";